import classNames from 'classnames';
import { PropsWithChildren, ReactNode } from 'react';
import InfoIcon from '@/shared/assets/icons/info.svg';
import s from './StatusBadge.module.scss';

export type StatusBadgeTone = 'orange' | 'dark' | 'green' | 'red' | 'gray';
export type StatusBadgeSize = 's' | 'm';

interface Props extends PropsWithChildren {
  tone: StatusBadgeTone;
  size?: StatusBadgeSize;
  className?: string;
  iconOnly?: boolean;
  customIcon?: ReactNode;
}

export const StatusBadge = ({ tone, size = 's', className, iconOnly, customIcon, children }: Props) => {
  return (
    <span
      className={classNames(s.root, s[tone], s[size], className, {
        [s.iconOnly]: iconOnly,
      })}
    >
      {customIcon === null ? null : customIcon || <InfoIcon className={s.icon} />}
      {!iconOnly && children}
    </span>
  );
};
